export const en = {
    'archived-campaign-modification': "You can't add keywords to archived campaigns",
    'max-keywords-exceeded': 'Exceeded the maximum of {maxKeywords} keywords per group',
    'validation-error': 'Failed to add keywords to the group. Try again later'
};
